import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { userFeedback } from 'redux-store/aiChatsReducers/aiChatsActions';
import { useDispatch } from 'react-redux';
import { useSnackbar } from "../../contexts/CustomSnackbarContext";
import { SendIcon, XIcon } from 'lucide-react';
import { MixpanelService } from 'utils/mixpanelService';

const FeedbackDialog = ({ visible, onClose, selectedMessageId, chatId, feedbackType }) => {
  useEffect(() => {
    if (visible) MixpanelService.track("feedback_modal_opened", { chat_id: chatId });
  }, [visible, chatId]);

  const handleClose = () => {
    MixpanelService.track("feedback_modal_closed", { chat_id: chatId });
    setFeedback('');
    onClose();
  };
    const dispatch = useDispatch();
    const [feedback, setFeedback] = useState('');
    const { openSnackbar } = useSnackbar();

    const handleSendFeedback = async () => {
        if (!feedback) {
            openSnackbar({ message: "Feedback cannot be empty.", severity: 'error' });
            return;
        }
        if (!selectedMessageId) {
            openSnackbar({ message: "No message selected.", severity: 'error' });
            return;
        }
        if (!chatId) {
            openSnackbar({ message: "No chat ID provided.", severity: 'error' });
            return;
        }
        try {
            const response = await dispatch(
                userFeedback({ aiChatId: chatId, aiChatMsgId: selectedMessageId, feedback, feedbackType })
            )
            if (response.payload.status === 200) {
                openSnackbar({ message: "Feedback Submitted.", severity: 'success' });
                setFeedback('');
                handleClose();
            }
        } catch (error) {
            console.error("Error Submitting Feedback.", error);
            openSnackbar({ message: "Error Submitting Feedback.", severity: 'error' });
        }
    };


    return (
        <Dialog
            visible={visible}
            modal
            onHide={handleClose}
            content={({ hide }) => (
                <div
                    className="flex flex-column p-4 gap-4"
                    style={{
                        width: "40vw",
                        borderRadius: '6px',
                        background: "var(--background-secondary)",
                        color: "var(--text-primary)",
                        border: "1px solid var(--borderColor)"
                    }}
                >
                    <div className='w-full'>
                        <div className="grid grid-cols-2 items-center gap-2">
                            <div>
                                <span className='!text-xl'>Feedback</span>
                            </div>
                            <div className="flex justify-end">
                                <Button
                                    type="button"
                                    icon={<XIcon size={16} />}
                                    className="w-auto h-8 bgSecondary hover:bg-[var(--hover-bg)] border-none text-[var(--text-primary)] px-2 py-1 m-1 !rounded shadow-none transition-all duration-150"
                                    onClick={handleClose}
                                />
                            </div>
                        </div>
                    </div>
                    {/* Feedback Textarea */}
                    <div className="w-full">
                        <label htmlFor="feedback" className="text-primary-50 text-xl font-semibold mb-3"></label>
                        <InputTextarea
                            id="feedback"
                            value={feedback}
                            onChange={(e) => setFeedback(e.target.value)}
                            rows={5}
                            cols={30}
                            autoResize
                            className="w-full bgPrimary text-[var(--text-primary)] border !border-[var(--borderColor)] p-3 overflow-y-auto chatscreen-custom-scrollbar outline-none shadow-none"
                            placeholder="Enter your feedback here..."
                            style={{ minHeight: '100px', maxHeight: '200px' }}
                        />
                    </div>

                    {/* Buttons */}
                    <div className="w-full flex justify-end gap-2">
                        <Button
                            className="w-full justify-center !rounded-lg border-none hover:bg-opacity-95 flex items-center"
                            onClick={handleSendFeedback}
                        >
                            <span>Send Feedback</span>
                        </Button>
                    </div>
                </div>
            )}
        />
    );
};

export default FeedbackDialog;
